import { render, staticRenderFns } from "./CasesEditBankModal.vue?vue&type=template&id=23e3991c"
import script from "./CasesEditBankModal.vue?vue&type=script&lang=js"
export * from "./CasesEditBankModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports